module.exports = __webpack_public_path__ + "img/chest.b5096992.png";